import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  situacaoSelecionada = null;

  connect() {
    const url = new URL(window.location);
    const ignorarKeys = ['resultados_por_pagina', 'ordenar_por', 'page', 'commit'];

    let searchParams = Array.from(url.searchParams.entries()).reduce((acc, [key, value]) => {
      if(value != null && value != undefined && value != '' && !ignorarKeys.includes(key)) {
        acc[key] = value;
      }
      return acc;
    }, {});
    if(Object.keys(searchParams).length == 1 && searchParams.status) {
      this.situacaoSelecionada = searchParams.status;
      const contador = document.querySelector(`span[data-situacao=${this.situacaoSelecionada}].contador__item`)
      if(contador) {
        contador.classList.add('contador__item--selecionado')
      }
    }
  }


  onClick(e) {
    const situacao = e.target.getAttribute('data-situacao') || e.target.parentElement.getAttribute('data-situacao');

    if(situacao) {
      window.location.href = `${window.location.pathname}?status=${situacao}`;
    }
  }
}